import script from "./UpdateChecker.vue?vue&type=script&lang=js"
export * from "./UpdateChecker.vue?vue&type=script&lang=js"

import "./UpdateChecker.vue?vue&type=style&index=0&id=4eb13ab3&lang=css"

const __exports__ = script;

export default __exports__